function applyDifferentialSlidesAnimation(slides) {
    const isObject = o => o != null && typeof o === "object";

    const applyDiff = (obj, diff) => {
        Object.keys(diff).forEach((key) => {
            if (diff.hasOwnProperty(key)) {
                if (obj.hasOwnProperty(key) && obj[key] !== null && isObject(diff[key])) {
                    applyDiff(obj[key], diff[key]);
                } else {
                    obj[key] = diff[key];
                }
            }
        });
    };

    const mergedSlides = [slides[0]];
    for (let i = 1; i < slides.length; i++) {
        mergedSlides[i] = Object.assign({}, slides[i]);
        mergedSlides[i].animation = JSON.parse(JSON.stringify(mergedSlides[i - 1].animation));//deep copy
        applyDiff(mergedSlides[i].animation, slides[i].animation);
    }
    return mergedSlides;
}

module.exports = applyDifferentialSlidesAnimation;